import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";
import { FaDiscord } from "react-icons/fa";
import { useRecoilState } from "recoil";

import { FloatingContainer, Modal } from "../../Wrappers";
import { AllstarModalState } from "../../../State/modals";
import { ModalType } from "../../../@types";
import theme from "theme/themeThree";

const DISCORD_INVITE_URL = "https://discord.gg/playsharestar";

export const DiscordSupportModal = () => {
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  if (allstarModalState.isOpen !== ModalType.DiscordSupport) return <></>;

  const handleClose = () => {
    setAllstarModalState({
      ...allstarModalState,
      isOpen: ModalType.None,
    });
  };

  return (
    <Modal
      isModalOpen={allstarModalState.isOpen === ModalType.DiscordSupport}
      setModalOpen={handleClose}
      handleModalClose={() => {}}
      disableOutsideClose={false}
    >
      <FloatingContainer>
        <ModalContainer>
          <IconContainer>
            <DiscordIcon />
          </IconContainer>
          <ContentSection>
            <Title variant="text.headingXSmall" color="ice">
              Get Support on Discord
            </Title>
            <BodyText variant="text.paragraphMedium" color="chalk">
              Support for free accounts is available through our Discord
              community. Join us to get help, share feedback, and connect with
              other players.
            </BodyText>
          </ContentSection>
          <ButtonContainer>
            <DiscordButton
              as="a"
              href={DISCORD_INVITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleClose}
            >
              <FaDiscord size={20} />
              <Text variant="text.labelSmall" fontWeight={500} color="ice">
                Join Our Discord
              </Text>
            </DiscordButton>
          </ButtonContainer>
        </ModalContainer>
      </FloatingContainer>
    </Modal>
  );
};

const ModalContainer = styled(Flex)`
  align-items: center;
  background-color: ${theme.colors.grey850};
  border: 1px solid ${theme.colors.chalkAlpha20};
  border-radius: 12px;
  flex-direction: column;
  gap: 24px;
  max-width: 500px;
  padding: 32px;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breaks.small}) {
    max-width: 90vw;
    padding: 24px;
  }
`;

const IconContainer = styled(Flex)`
  align-items: center;
  background: ${theme.colors.chalkAlpha10};
  border-radius: 50%;
  height: 64px;
  justify-content: center;
  width: 64px;
`;

const DiscordIcon = styled(FaDiscord)`
  color: ${theme.colors.ice};
  height: 32px;
  width: 32px;
`;

const ContentSection = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  width: 100%;
`;

const Title = styled(Text)`
  font-weight: 600;
  line-height: 1.2;
`;

const BodyText = styled(Text)`
  line-height: 1.5;
  max-width: 400px;
`;

const ButtonContainer = styled(Flex)`
  align-items: center;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const DiscordButton = styled(Flex)`
  align-items: center;
  background: #5865f2;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  color: ${theme.colors.ice};
  cursor: pointer;
  gap: 8px;
  justify-content: center;
  padding: 10px 20px;
  text-decoration: none;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: ${(props) => props.theme.breaks.small}) {
    padding: 8px 16px;
  }
`;
